import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { TranslateService } from '@devinforius/i-essentials';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FileUpload } from 'primeng/fileupload';
import { iAdminService } from 'src/app/shared/services/i-admin.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss'],
})
export class SignatureComponent implements OnInit {
  public title: string;
  public signatureBtn: string;
  public noSignature: string;

  public mySignature: SafeUrl;

  constructor(
    public toastr: ToastrService,
    private translate: TranslateService,
    private iadminService: iAdminService,
    private sanitizer: DomSanitizer,
    private spinner: NgxSpinnerService
  ) {
    if (sessionStorage.getItem('clientType') === 'JVS') {
      this.title = this.translate.translate('account.signatureJVS');
      this.signatureBtn = this.translate.translate('account.selectSignatureJVS');
      this.noSignature = this.translate.translate('account.noSignatureJVS');
    } else {
      this.title = this.translate.translate('account.signature');
      this.signatureBtn = this.translate.translate('account.selectSignature');
      this.noSignature = this.translate.translate('account.noSignature');
    }
  }

  ngOnInit(): void {
    this.getMySignature();
  }

  private getMySignature(): void {
    this.iadminService.getMySignature().subscribe({
      next: (response) => {
        this.mySignature = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(response));
      },
      error: () => {
        this.mySignature = null;
      },
    });
  }

  public onSelectFiles(event, pFileUpload: FileUpload): void {
    this.spinner.show();
    if (event.currentFiles.length > 0) {
      const file = _.first(event.currentFiles);
      this.iadminService.putMySignature(file).subscribe({
        next: () => {
          this.toastr.success("L'image de signature a bien été modifiée");
          pFileUpload.clear();
          this.getMySignature();
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error("Une erreur s'est produite lors de la sauvegarde de la signature");
        },
      });
    }
  }
}
